module.exports = __webpack_public_path__ + "h5/img/bs_04.d7176cb2.jpg";